{
  "pt": {
    "form": {
      "actions": {
        "cancel": "Cancelar",
        "clear": "Limpar",
        "closeFullPage": "Fechar página inteira",
        "copyText": "Clique para copiar o texto",
        "create_and_send_to_customer": "Criar e enviar ao cliente",
        "create_and_share": "Criar e partilhar com o cliente",
        "create_and_share_partners_only": "Criar e partilhar com parceiro(s)",
        "create_and_share_with_partners": "Criar e partilhar com o cliente e parceiro(s)",
        "next": "Seguinte",
        "only_create": "Apenas criar",
        "openFullPage": "Abrir em página inteira",
        "save": "Guardar",
        "saveChanges": "Guardar alterações",
        "search": "Pesquisar...",
        "send": "Enviar",
        "send_and_create_another": "Enviar e criar outro",
        "send_to_customer": "Enviar ao cliente",
        "share_with_customer": "Partilhar com o cliente",
        "submit": "Enviar",
        "submit_and_create_another": "Submeter e criar outro"
      },
      "back": "Etapa anterior",
      "labels": {
        "columns": "Colunas",
        "from": "De",
        "no_results": "Sem resultados",
        "to": "Até"
      },
      "notifications": {
        "textHasBeenCopied": "O texto foi copiado"
      },
      "password": "Palavra-passe",
      "shortcuts": {
        "save_mac": "⌘ + Enter para guardar",
        "save_windows": "Ctrl + Enter para guardar",
        "send_mac": "⌘ + Enter para enviar",
        "send_windows": "Ctrl + Enter para enviar"
      },
      "steps": "Passo {count} de {total}",
      "writeEmployeeNameReject": "Escreva <i><b>{employeeName}</b></i> para continuar."
    }
  }
}
